import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function ServicesAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const services = [{
    title: 'Engineer Callout & Diagnostics',
    description: 'Our qualified engineer visits your property to inspect the appliance and diagnose the fault. Includes a detailed assessment and transparent quote for any repairs needed.'
  }, {
    title: 'Repair Visit (Labour Only)',
    description: 'Professional repair service where our engineer completes the necessary work to restore your appliance. This covers labour time and expertise for the repair work.'
  }, {
    title: 'Service & Maintenance Visit',
    description: 'Preventative maintenance to keep your appliances running efficiently. Our engineer performs safety checks, cleaning, and adjustments to extend appliance life.'
  }];
  return <div className="space-y-3" data-id="element-127">
      {services.map((service, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden border border-slate-200" data-id="element-128">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-slate-50 transition" data-id="element-129">
            <span className="font-semibold text-slate-800" data-id="element-130">
              {service.title}
            </span>
            {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-teal-600 flex-shrink-0" data-id="element-131" /> : <ChevronDownIcon className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-132" />}
          </button>
          {openIndex === index && <div className="px-6 pb-4 border-t border-slate-100" data-id="element-133">
              <p className="text-slate-600 pt-4" data-id="element-134">{service.description}</p>
            </div>}
        </div>)}
    </div>;
}